import { render, staticRenderFns } from "./VendorDialog.vue?vue&type=template&id=53fc973a"
import script from "./VendorDialog.vue?vue&type=script&lang=js"
export * from "./VendorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports